/* eslint-disable max-len */
import React from 'react';

const IssueReportFill = (props: React.ComponentProps<'svg'>) => {
    return (
        <svg
            {...props}
            xmlns={'http://www.w3.org/2000/svg'}
            width={'1rem'}
            height={'1rem'}
            viewBox={'0 0 16 16'}
            fill={'none'}
        >
            <path
                fillRule={'evenodd'}
                clipRule={'evenodd'}
                d={
                    'M2 1.5C2.13261 1.5 2.25979 1.55268 2.35355 1.64645C2.44732 1.74021 2.5 1.86739 2.5 2V2.36L3.72533 2.05333C5.2306 1.67697 6.82084 1.85149 8.20867 2.54533L8.28067 2.58133C9.43144 3.1568 10.7475 3.31061 12 3.016L14.0733 2.528C14.1511 2.50976 14.2321 2.51042 14.3095 2.52991C14.387 2.54941 14.4587 2.58717 14.5185 2.64005C14.5784 2.69293 14.6247 2.75937 14.6536 2.83383C14.6825 2.90829 14.6932 2.98858 14.6847 3.068C14.4366 5.35847 14.4377 7.6691 14.688 9.95933C14.7013 10.0807 14.6698 10.2028 14.5993 10.3025C14.5288 10.4023 14.4242 10.4727 14.3053 10.5007L12.2293 10.9893C10.7491 11.3377 9.1935 11.1561 7.83333 10.476L7.76133 10.44C6.58714 9.85284 5.24165 9.70505 3.968 10.0233L2.5 10.39V14C2.5 14.1326 2.44732 14.2598 2.35355 14.3536C2.25979 14.4473 2.13261 14.5 2 14.5C1.86739 14.5 1.74021 14.4473 1.64645 14.3536C1.55268 14.2598 1.5 14.1326 1.5 14V2C1.5 1.93434 1.51293 1.86932 1.53806 1.80866C1.56319 1.748 1.60002 1.69288 1.64645 1.64645C1.69288 1.60002 1.748 1.56319 1.80866 1.53806C1.86932 1.51293 1.93434 1.5 2 1.5Z'
                }
                fill={'currentColor'}
            />
        </svg>
    );
};
export default IssueReportFill;
